import { UPDATE_FILTERS, RESET_FILTERS, DEFAULT_FILTERS, FILTERS_STATE } from './constants'
import defaultState from 'client/state'
import type { FiltersActions } from './actions'
import type { FiltersState } from './state'

const filtersState: FiltersState = defaultState[FILTERS_STATE]

const reducer = (state = filtersState, action: FiltersActions) => {
  switch (action.type) {
    case UPDATE_FILTERS: {
      const {
        family,
        facilities,
        orderBy,
        stars,
        ratings,
        accommodationTypes,
        minPrice,
        maxPrice,
        themes,
        boards,
        paymentOptions,
        cancellationPolicies,
      } = action.payload

      return {
        ...state,
        hasFiltered: true,
        family,
        facilities,
        orderBy,
        stars,
        ratings,
        accommodationTypes,
        minPrice,
        maxPrice,
        themes,
        boards,
        paymentOptions,
        cancellationPolicies,
      }
    }

    case RESET_FILTERS: {
      return {
        ...DEFAULT_FILTERS,
      }
    }

    default: {
      return state
    }
  }
}

export default reducer
